<template>
    <div class="kgr-inputGroup kgr-inputGroup--constrainedWidth">
        <kgr-dog-avatar-form-row
            v-if="editMode"
            :dog="dog"
        />
        <kgr-form-row
            :label="$t('Name')"
            :error="error"
            field-name="name"
            required
        >
            <input
                v-model.trim="dog.name"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Geschlecht')"
            :error="error"
            field-name="gender"
            required
        >
            <kgr-generic-select
                v-model="dog.gender"
                :options="genderOptions"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('Wurfdatum')"
            :error="error"
            field-name="dateOfBirth"
        >
            <kgr-date-picker
                v-model.trim="dog.dateOfBirth"
                @enter="onKeyUpEnter"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Todesdatum')"
            :error="error"
            field-name="dateOfDeath"
        >
            <kgr-date-picker
                v-model.trim="dog.dateOfDeath"
                @enter="onKeyUpEnter"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Chipnummer')"
            :error="error"
            field-name="chipNumber"
        >
            <input
                v-model.trim="dog.chipNumber"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Rasse')"
            :error="error"
            field-name="breed"
        >
            <kgr-dog-breed-select
                v-model="dog.breed"
                :club-id="clubId"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Rasse Spezialisierung')"
            :error="error"
            field-name="breedSpecialization"
        >
            <kgr-dog-breed-specialization-select
                v-model="dog.breedSpecialization"
                :club-id="clubId"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Zuchtbuchnummer')"
            :error="error"
            field-name="breedingBookNumber"
        >
            <input
                v-model.trim="dog.breedingBookNumber"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import DatePicker from '../common/form/picker/DatePicker.vue';
import Dog from '../../js/dto/Dog.js';
import DogAvatarFormRow from './DogAvatarFormRow.vue';
import DogBreedSelect from './DogBreedSelect.vue';
import DogBreedSpecializationSelect from './DogBreedSpecializationSelect.vue';
import Error from '../../js/model/Error.js';
import FormRow from '../common/form/FormRow.vue';
import GenericSelect from '../common/form/select/GenericSelect.vue';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
        'kgr-generic-select': GenericSelect,
        'kgr-dog-breed-select': DogBreedSelect,
        'kgr-dog-breed-specialization-select': DogBreedSpecializationSelect,
        'kgr-dog-avatar-form-row': DogAvatarFormRow,
    },
    props: {
        newDog: {
            type: Dog,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            dog: this.newDog,
            genderOptions: [
                'club.dog.gender.f',
                'club.dog.gender.m',
            ],
        };
    },
    watch: {
        dog(dog) {
            this.$emit('update', dog);
        },
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
